import Checkbox from "@mui/material/Checkbox";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { styled as muiStyled } from "@mui/material/styles";
import styled from "styled-components";
import ConnorsTheme from "../connorsTheme";

export const OverlayBackground = styled(Grid)`
  && {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 104px;
    z-index: 100;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 2rem 1.5rem 1.5rem;
    overflow-y: auto;
    background-color: ${ConnorsTheme.black};
    background-image: linear-gradient(rgba(0, 0, 0, 0.45), rgba(0, 0, 0, 0.45)),
      url("https://assets.wobbjobs.com/images/connors-popup-bg.png");
    background-size: cover;
    background-position: bottom;
    background-repeat: no-repeat;
    font-family: "Hops and Barley C4", "Helvetica Neue", Helvetica, Arial,
      sans-serif;

    @media (max-width: 1279px) {
      top: 92px;
    }

    @media (max-width: 639px) {
      top: 100px;
      padding: 1.5rem 1rem 1rem;
    }
  }
`;

export const ContentContainer = styled(Grid)`
  && {
    width: 100%;
    max-width: 820px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 2rem;
    flex: 1;
    justify-content: center;

    @media (max-width: 639px) {
      gap: 1.25rem;
    }
  }
`;

export const LogoImage = styled.img`
  width: 320px;
  height: auto;
  object-fit: contain;

  @media (max-width: 639px) {
    width: 250px;
  }
`;

export const CollectiveTitle = styled(Typography)`
  && {
    font-size: 5rem;
    font-weight: 400;
    letter-spacing: 0.08rem;
    line-height: 1;
    color: #ffffff;
    text-transform: uppercase;
    font-family: "Hops and Barley C4", "Helvetica Neue", Helvetica, Arial,
      sans-serif;
    margin-top: -0.8rem;
    margin-bottom: 20px;

    @media (max-width: 639px) {
      font-size: 3.5rem;
      margin-top: -0.4rem;
    }
  }
`;

export const ConfirmationText = styled(Typography)`
  && {
    font-size: 2rem;
    font-weight: 400;
    letter-spacing: 0.04rem;
    line-height: 1.15;
    color: #ffffff;
    text-transform: uppercase;
    max-width: 780px;
    font-family: "Hops and Barley C4", "Helvetica Neue", Helvetica, Arial,
      sans-serif;

    @media (max-width: 639px) {
      font-size: 1.5rem;
      line-height: 1.2;
    }
  }
`;

export const ButtonRow = styled(Grid)`
  && {
    display: flex;
    gap: 1rem;
    width: 100%;
    max-width: 520px;
    justify-content: center;

    @media (max-width: 480px) {
      flex-direction: row;
      max-width: 350px;
    }
  }
`;

export const AgeGateButton = styled.button`
  flex: 1;
  min-width: 0;
  min-height: 35px;
  padding: 0.6rem 0.8rem 0.3rem;
  background: #ec0036;
  border: 1px solid #ec0036;
  border-radius: 8px;
  color: #ffffff;
  font-size: 1.5rem;
  line-height: 1.1;
  font-weight: 400;
  text-transform: uppercase;
  font-family: "Hops and Barley C4", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  cursor: pointer;
  transition: filter 0.2s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-align: center;

  &:hover {
    filter: brightness(1.1);
  }

  @media (max-width: 480px) {
    width: 100%;
    font-size: 1.2rem;
    min-height: 35px;
  }
`;

export const CheckboxRow = styled(Grid)`
  && {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: -0.25rem;
  }
`;

export const WhiteCheckbox = muiStyled(Checkbox)({
  color: "rgba(255, 255, 255, 0.7)",
  "&.Mui-checked": {
    color: "#ffffff",
  },
});

export const DisclaimerText = styled(Typography)`
  && {
    width: 100%;
    max-width: 900px;
    margin-top: auto;
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
    font-size: 0.95rem;
    line-height: 1.2;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.85);
    text-align: center;
    text-transform: uppercase;
    font-family: "Hops and Barley C4", "Helvetica Neue", Helvetica, Arial,
      sans-serif;

    @media (max-width: 639px) {
      font-size: 0.7rem;
      line-height: 1.15;
    }
  }
`;
